import React from 'react';
import Navbar from '../components/Navbar';
import Showcase from '../components/Showcase';
import Footer from '../components/Footer';

export default function ShowcasePage() {
  return (
    <div>
      <Navbar />
      <div className="pt-24">
        <div className="text-center pt-8 pb-2">
          <span className="inline-flex px-3 py-1 rounded-full bg-neutral-100 text-xs font-medium text-neutral-700">
            Showcase
          </span>
        </div>
        <Showcase />
      </div>
      <Footer />
    </div>
  );
}
